import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Table, Image, Header, Container, Label } from 'semantic-ui-react';
import _ from 'lodash';

//Table Components
import { TableFooter } from './TableFooter';
import { TableRow } from './TableRow';
import { TableHeader } from './TableHeader';
import { TableHeaderFilter } from './TableHeaderFilter';

//Some converter components
import convertCamelCase from '../../../helpers/convert-camel-case.js';
import convertStatusName from '../../../helpers/convert-status-name.js';

//Other Component
import NoSearchFoundImage from '../../../images/grafix-banner/gfx-no-results.svg'
import PlaceholderExampleHeaderImage from '../PlaceHolder/PlaceHolderLoading.jsx';
import NothingToShow from '../NothingToShow';
import LoadingComponent from '../../common/LoadingComponent';


export const CommonTableLayout = props => {
	//If table data is not available so show loader
	if (!props.tableData) {
		
		return <div style={{ border: "1px solid rgba(34,36,38,.15)" }} >
			<LoadingComponent active={true || this.props.loader }  message="Loading..." /> 
			 {/* <PlaceholderExampleHeaderImage repeat={5} /> */}
		</div >;
	}
	//It will create the "filter key : filter Value" combibation of the search 
	//result and will be display if the search result is not available. 
	let key1, key2, key3, value1, value2, value3, key4, key5, key6, value4, value5, value6, key7, value7, key8, value8, key9, value9;
	if (_.isEmpty(props.filterByDropdown)) { }
	else {
		key1 = Object.keys(props.filterByDropdown)[0];
		value1 = Object.values(props.filterByDropdown)[0];

		key2 = Object.keys(props.filterByDropdown)[1];
		value2 = Object.values(props.filterByDropdown)[1];

		key3 = Object.keys(props.filterByDropdown)[2];
		value3 = Object.values(props.filterByDropdown)[2];

	}
	if (_.isEmpty(props.filterByText)) { }
	else {

		key4 = Object.keys(props.filterByText)[0];
		value4 = Object.values(props.filterByText)[0];

		key5 = Object.keys(props.filterByText)[1];
		value5 = Object.values(props.filterByText)[1];

		key6 = Object.keys(props.filterByText)[2];
		value6 = Object.values(props.filterByText)[2];
	}

	if (_.isEmpty(props.filterByDate)) { }
	else {
		key7 = Object.keys(props.filterByDate)[0];
		value7 = Object.values(props.filterByDate)[0];
	}

	if (_.isEmpty(props.filterByTextObject)) { }
	else {
		key8 = Object.keys(props.filterByTextObject)[0];
		value8 = Object.values(props.filterByTextObject)[0];

		key9 = Object.keys(props.filterByTextObject)[1];
		value9 = Object.values(props.filterByTextObject)[1];
	}

	// Blank page will display for different senario
	// 1. Data : null
	// 2. Filter Data : null (will show the key : value filter) 

	let noRecordAvailable = <Table.Row  >
		<Table.Cell className="text-center" colSpan={props.tableHeader && props.tableHeader.length * 2}>
			<NothingToShow />
		</Table.Cell>
	</Table.Row>

	//  Loader will apear while fetching content list 
	let loadingTablelist = props.loading && props.column !="email" ?
	<LoadingComponent active={true}  message="Loading..." /> : null;
	//Generate Table Row with the hep of table Header JSON and data 
	const tableRows = props.tableData && props.tableData.map((obj, index) => (
		<TableRow
			key={index}
			i={index}
			data={obj}
			isAccountDeactivated={props.isAccountDeactivated}
			tableHeader={props.tableHeader}
			loading={props.loading}
			resetPassword={props.resetPassword}
			handleDropDownItem={props.handleDropDownItem}
			handleTableComponent={props.handleTableComponent}
			selection={props.selection}
			actionType={props.actionType}
			rowHighlight={props.rowHighlight}
			selectedRowHighlight={props.selectedRowHighlight}
		/>
	));
	return (
		<React.Fragment>
			{loadingTablelist}
			<Table
				selectable={props.selection ? props.selection : false}
				className="semantic-table sortable table mar_0"
				celled
			>
				<TableHeader
					column={props.column}
					direction={props.direction}
					handleSort={props.handleSort}
					tableHeader={props.tableHeader}
					addColumn={props.addColumn}
					q={props.q}
					onSubmitFilter={props.onSubmitFilter}
					loading={props.loading}
					type="Multiple Search"
					headerClickHideResourcePane={props.headerClickHideResourcePane}
					showFilterHeader={props.showFilterHeader}
					resetFilter={props.resetFilter}
					downloadAsCSV={props.downloadAsCSV}
					changeMenuView={props.changeMenuView}
					actionType={props.actionType}
					csvData={props.csvData}
					handleTableComponent={props.handleTableComponent}
					defaultMarkAll={props.defaultMarkAll}
				/>
				{props.filterHeader ?
					<React.Fragment>
						<TableHeaderFilter
							column={props.column}
							direction={props.direction}
							handleSort={props.handleSort}
							tableHeader={props.tableHeader}
							addColumn={props.addColumn}
							q={props.q}
							onSubmitFilter={props.onSubmitFilter}
							loading={props.loading}
							filterByDate={props.filterByDate}
							filterByDropdown={props.filterByDropdown}
							filterByText={props.filterByText}
							filterByTextObject={props.filterByTextObject}
							//type="Multiple Search"
							headerClickHideResourcePane={props.headerClickHideResourcePane}
						/>
					</React.Fragment> : null}
				<Table.Body className='table-body'>
					{props.loading? 
					<Table.Cell colSpan="10">
						<PlaceholderExampleHeaderImage repeat={1} />
						</Table.Cell> : tableRows}
					{props.tableData && props.tableData.length === 0 && !props.loading ? noRecordAvailable : null}
				</Table.Body>
				{props.tableData && props.tableData.length === 0 ? null :
					<Table.Footer className='table-footer'>
						{!props.loading ?
						<Table.Row>
							<Table.HeaderCell
								colSpan={props.tableHeader && props.tableHeader.length * 2}
								className="text-left"
							>
								<TableFooter
									limit={props.limit}
									query={props.query}
									onChangeLimit={props.onChangeLimit}
									totalCount={props.totalCount}
									active_Page={props.currentPage}
									currentPage={props.currentPage}
									total_Pages={props.totalPages}
									onChangePage={props.onChangePage}
								/>
							</Table.HeaderCell>
						</Table.Row> : null }
					</Table.Footer>
				}
			</Table>
		</React.Fragment>
	);
};

CommonTableLayout.propTypes = {
	totalCount: PropTypes.number.isRequired,
	totalPages: PropTypes.number.isRequired,
	currentPage: PropTypes.number.isRequired,
	onChangePage: PropTypes.func.isRequired,
	onChangeLimit: PropTypes.func.isRequired,
	limit: PropTypes.string.isRequired,
	tableHeader: PropTypes.array.isRequired,
	handleDropDownItem: PropTypes.func.isRequired,
	addColumn: PropTypes.func.isRequired,
	q: PropTypes.object.isRequired,
	tableData: PropTypes.array.isRequired,
	query: PropTypes.object.isRequired,
	handleTableComponent: PropTypes.func.isRequired,
	selection: PropTypes.bool.isRequired,
	headerClickHideResourcePane: PropTypes.func.isRequired,
	downloadAsCSV: PropTypes.func.isRequired,
	filterByDate: PropTypes.object.isRequired,
	filterByDropdown: PropTypes.object.isRequired,
	filterByText: PropTypes.object.isRequired,
	changeMenuView: PropTypes.func.isRequired,
	actionType: PropTypes.string.isRequired,
	csvData: PropTypes.array.isRequired,
	showFilterHeader: PropTypes.func.showFilterHeader,
	resetFilter: PropTypes.func.resetFilter,
	filterHeader: PropTypes.bool.isRequired,
	rowHighlight: PropTypes.string,
	selectedRowHighlight: PropTypes.func,
	defaultMarkAll: PropTypes.bool

};